module.exports = __webpack_public_path__ + "img/participant-picture@dt-2.fc270aa.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participant-picture@dt-2.svg
// module id = /b08
// module chunks = 0